import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { EInvoicesKYCNotAllowed } from '../../../../assets/images'
import { EInvoicingGenericStatus } from '../EInvoicingGenericStatus'

export const EInvoicingKYCNotAllowed = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <EInvoicingGenericStatus
      title={t('e_invoice.kyc.step.status.not_allowed.title')}
      illustration={EInvoicesKYCNotAllowed}
    >
      <Text alignment="center">
        <Trans i18nKey="e_invoice.kyc.step.status.not_allowed.subtitle" components={{ strong: <strong /> }} />
      </Text>
    </EInvoicingGenericStatus>
  )
}
